//* 오퍼월 SSOT — 벤더 마커와 OS별 지면·인벤토리를 여기서만 관리한다.
//* 혜택 "오늘의 미션"(어드민 placementKey)은 아래 벤더 마커 문자열만 유효하고
//* resolveOfferwallVendor가 이 파일 값으로 분기한다. 고정 진입점(마이페이지 등)은 useAdpopcorn이 소비.

export const OFFERWALL_VENDOR = {
  ADPOPCORN: 'adpopcorn',
  ADISON: 'adison',
  PINCRUX: 'pincrux',
} as const;

export const ADPOPCORN_PLACEMENT_IDS = {
  //* 홈 화면 상단 퀵메뉴 "혜택"
  HOME_QUICK_MENU: {
    android: '9OT0HR3hgIze',
    ios: 'q2ysL5KbViPJ',
  },
  //* 하단 네비게이션 "혜택" — 일반 화면
  BOTTOM_NAV: {
    android: 'HNgUu6TyfYX4',
    ios: 'taXej7CSQ9LT',
  },
  //* 하단 네비게이션 "혜택" — 웰마켓 화면
  BOTTOM_NAV_WELMARKET: {
    android: 'Xoxr71EFut6M',
    ios: 'IeqtJjb1t462',
  },
  //* 우측 상단 메뉴 팝오버 + 마이페이지 메뉴 "혜택"
  MY_ENTRY: {
    android: 'cNmOt5cfk5Hl',
    ios: 'YlemNwjsRiGS',
  },
  //* 혜택 "오늘의 미션" 오퍼월 항목(어드민 placementKey='adpopcorn' 벤더 마커가 이 페어로 OS 분기).
  BENEFIT_MISSION: {
    android: '9OT0HR3hgIze',
    ios: 'q2ysL5KbViPJ',
  },
} as const;

export type AdpopcornPlacementKey = keyof typeof ADPOPCORN_PLACEMENT_IDS;

//* TODO(애디슨 콘솔): 혜택 "오늘의 미션" 인벤토리 발급 후 채움 — 빈 값이면 해당 항목이 비활성으로 노출된다.
export const ADISON_BENEFIT_MISSION_INVENTORIES = {
  android: '',
  ios: '',
} as const;
